<form name="formApproveReject">
    <div class="row">
        <div class="col-md-12">{{ "DATASET_DIALOG.CHOOSE" | translate }}</div>
    </div>
    <div class="row">
        <div class="col-md-12">&nbsp;</div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label>
                <input type="radio" [(ngModel)]="extendedTechApproveAction" value="extendedTechApprove" name="extendedTechApproveAction" (ngModelChange)="onExtendedTechApproveActionChanged()" />
                {{ "DATASET_DIALOG.LABEL.OKAY" | translate }}
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label>
                <input type="radio" [(ngModel)]="extendedTechApproveAction" value="extendedTechReject" name="extendedTechApproveAction" (ngModelChange)="onExtendedTechApproveActionChanged()" />
                {{ "DATASET_DIALOG.LABEL.NOT_OKAY" | translate }}
            </label>
        </div>
    </div>
    <div class="row">
        @if (extendedTechApproveAction === "extendedTechApprove") {
            <div class="col-md-12 mb-2">{{ "DATASET_DIALOG.EXTENDED_TECH.OKAY.TEXT" | translate }}</div>
        }
        @if (extendedTechApproveAction === "extendedTechReject") {
            <div class="col-md-12 mb-2">{{ "DATASET_DIALOG.EXTENDED_TECH.NOT_OKAY.TEXT" | translate }}</div>
        }
        <div class="col-md-12">
            <textarea class="rejectcomment form-control" [(ngModel)]="dataset.extendedTechnicalCheckNote" name="extendedTechnicalCheckNote" (ngModelChange)="onExtendedTechnicalCheckNoteChanged()"></textarea
            >
            <br />
        </div>
        <div class="col-md-12">
            <label
                class="form-group"
            >{{ "DATASET_DIALOG.EXTENDED_TECH.FILE" | translate }}
                <gp-file (onFileSelected)="onFileSelected($event)" accept=".pdf"></gp-file>
            </label>
        </div>
    </div>
</form>
